import { ServiceRoute } from "./../../base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { CommonHttpOption } from "../../base/common-http-option";
import { IListCourseForRegister } from "src/app/interfaces/registration-listCourseForRegister";
import { IRegistration } from "src/app/interfaces/registration";
import { Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class RegistrationService {
  constructor(private core: CoreService) { }

  getListLevelFromNationalCode(nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.registration.getListLevelFromNationalCode + nationalCode,
      new CommonHttpOption().headers
    );
  }
  registerFullList(filter: any, pageIndex: number, pageSize: number, headers: HttpHeaders): Observable<any> {
    return this.core.get(
      ServiceRoute.registration.registerFullList,
      headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize, "Id", true)
        .append('FullName', filter && filter.FullName ? filter.FullName : '')
        .append('CompanyEncryptId', filter && filter.CompanyEncryptId ? filter.CompanyEncryptId : '')
        .append('BranchEncryptId', filter && filter.BranchEncryptId ? filter.BranchEncryptId : '')
        .append('LevelInfoId', filter && filter.LevelInfoId ? filter.LevelInfoId : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('CellPhoneNumber', filter && filter.CellPhoneNumber ? filter.CellPhoneNumber : '')
        .append('PackageId', filter && filter.PackageId ? filter.PackageId : '')
        .append('RegisterStartDate', filter && filter.RegisterStartDate ? filter.RegisterStartDate : '')
        .append('RegisterEndDate', filter && filter.RegisterEndDate ? filter.RegisterEndDate : '')
    );
  }
  listCourseForRegister(data: IListCourseForRegister): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.listCourseForRegister,
      data,
      new CommonHttpOption().headers
    );
  }


  registerStudentList(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.registerJustStudentList,
      data,
      new CommonHttpOption().headers
    );
  }

  addPrivateClassRegistrationInvoice(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.addPrivateClassRegistrationInvoice,
      data,
      new CommonHttpOption().headers
    );
  }

  cancelRegistration(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.registration.cancelRegistration,
      new CommonHttpOption().headers,
      data
    );
  }

  // update(data: any): Observable<any> {
  //   return this.core.post(
  //     ServiceRoute.registration.update,
  //     data,
  //     new CommonHttpOption().headers
  //   );
  // }

  addWithOutPlacement(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.addWithOutPlacement,
      data,
      new CommonHttpOption().headers
    );
  }

  addAgh(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.addAgh,
      data,
      new CommonHttpOption().headers
    );
  }

  removeAghRegistration(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.registration.removeAghRegistration,
      new CommonHttpOption().headers,
      data
    );
  }

  removePrivateRegistration(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.registration.removePrivateRegistration,
      new CommonHttpOption().headers,
      data
    );
  }

  add(data: IRegistration): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.add,
      data,
      new CommonHttpOption().headers
    );
  }

  moveStudentToOtherClass(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.moveStudentToOtherClass,
      data,
      new CommonHttpOption().headers
    );
  }

  setEduOrg(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.registration.setEduOrg,
      data,
      new CommonHttpOption().headers
    );
  }
}
